import { ApiError } from "@custos/api-client";

/** A message that is safe and useful to show. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code === "INVALID_CODE") {
      return "That 2FA code is wrong or was already used. Wait for the next code in your app and try again.";
    }
    if (error.code === "VALIDATION_ERROR" && error.issues[0]) return error.issues[0].message;
    if (error.code === "ACCOUNT_LOCKED") {
      const until = /after (\S+)$/.exec(error.message)?.[1];
      const when = until ? new Date(until) : null;
      return when && !Number.isNaN(when.getTime())
        ? `Too many failed attempts. Try again after ${when.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}.`
        : error.message;
    }
    return error.message;
  }
  return "Something went wrong. Please try again.";
}

export const isApiError = (error: unknown, code: string) => error instanceof ApiError && error.code === code;
